import { immerable } from "immer";

export default class Movie {
    [immerable] = true;

    constructor(newMovieObject) {
        this.movieObject = newMovieObject;
        this.selectedData = null;
        this.__standarizeMovie();
    }

    get data() {
        return this.movieObject;
    }

    get selectedItem() {
        if (this.selectedData) {
            const selectedItem = this.getItemByCoords(this.selectedData.sceneIndex, this.selectedData.elementIndex);
            if (selectedItem) {
                return selectedItem.pointer;
            }
        }
        return null;
    }

    get selected() {
        if (this.selectedData) {
            return {
                ...this.selectedData,
                pointer: this.selectedItem
            }
        }
        return null;
    }

    // STANDARIZE METHODS
    __standarizeMovie() {
        let standardMovie = JSON.parse(JSON.stringify(this.movieObject));

        if (!standardMovie || typeof standardMovie !== "object") {
            standardMovie = defaultMovie;
        }

        standardMovie.scenes = standardMovie.scenes || [];
        standardMovie.elements = standardMovie.elements || [];

        // add id to movie object
        if (!standardMovie.id) standardMovie = {
            id: this.getRandomId(),
            ...standardMovie
        };

        // add ids to scenes and scene elements
        if (Array.isArray(standardMovie.scenes)) {
            for (let i = 0; i < standardMovie.scenes.length; i++) {
                if (!standardMovie.scenes[i].id) {
                    standardMovie.scenes[i] = {
                        id: this.getRandomId(),
                        ...standardMovie.scenes[i]
                    };
                }

                // make sure scenes have elements
                if (!standardMovie.scenes[i].elements) standardMovie.scenes[i].elements = [];

                if (Array.isArray(standardMovie.scenes[i].elements)) {
                    for (let j = 0; j < standardMovie.scenes[i].elements.length; j++) {
                        if (!standardMovie.scenes[i].elements[j].id) {
                            standardMovie.scenes[i].elements[j] = {
                                id: this.getRandomId(),
                                ...standardMovie.scenes[i].elements[j]
                            };
                        }
                    }
                }
            }
        }
        

        // add ids to elements
        if (Array.isArray(standardMovie.elements)) {
            for (let i = 0; i < standardMovie.elements.length; i++) {
                if (!standardMovie.elements[i].id) {
                    standardMovie.elements[i] = {
                        id: this.getRandomId(),
                        ...standardMovie.elements[i]
                    };
                }
            }
        }

        this.movieObject = standardMovie;
    }

    getRandomId() {
        return "q"+Math.random().toString(36).substring(2, 9);
    }

    // GET ITEM PROPERTIES

    // returns a pointer to the item with id = itemId
    getItemById(itemId) {
        const movieObject = this.movieObject;
        if (!movieObject) {
            return null;
        }

        // if the item is the movie
        if (movieObject.id && movieObject.id === itemId) return {
            pointer: movieObject,
            itemId: itemId,
            sceneIndex: -1,
            elementIndex: -1,
            type: "movie"
        };

        // if the item is in the movie elements array
        if (Array.isArray(movieObject.elements)) {
            for (let i = 0; i < movieObject.elements.length; i++) {
                if (movieObject.elements[i].id === itemId) {
                    return {
                        pointer: movieObject.elements[i],
                        itemId: itemId,
                        sceneIndex: -1,
                        elementIndex: i,
                        type: "element"
                    }
                }
            }
        }

        // if the item is in the scenes
        if (Array.isArray(movieObject.scenes)) {
            for (let i = 0; i < movieObject.scenes.length; i++) {
                if (movieObject.scenes[i].id === itemId) {
                    return {
                        pointer: movieObject.scenes[i],
                        itemId: itemId,
                        sceneIndex: i,
                        elementIndex: -1,
                        type: "scene"
                    }
                }
                // check elements inside the scene
                if (Array.isArray(movieObject.scenes[i].elements)) {
                    for (let j = 0; j < movieObject.scenes[i].elements.length; j++) {
                        if (movieObject.scenes[i].elements[j].id === itemId) {
                            return {
                                pointer: movieObject.scenes[i].elements[j],
                                itemId: itemId,
                                sceneIndex: i,
                                elementIndex: j,
                                type: "element"
                            }
                        }
                    }
                }
            }
        }

        // if the item id does not exist, return null
        return null;
    }

    getItemCopyById(itemId) {
        const item = this.getItemById(itemId);
        if (item) return {
            pointer: JSON.parse(JSON.stringify(item.pointer)),
            itemId: item.itemId,
            sceneIndex: item.sceneIndex,
            elementIndex: item.elementIndex,
            type: item.type
        }
        return null;
    }

    getItemByCoords(sceneIndex, elementIndex) {
        const movieObject = this.movieObject;
        if (!movieObject) {
            return null;
        }

        sceneIndex = parseInt(sceneIndex);
        elementIndex = parseInt(elementIndex);

        if (sceneIndex >= 0) {
            if (elementIndex>=0) {
                if (movieObject.scenes && movieObject.scenes[sceneIndex] && movieObject.scenes[sceneIndex].elements && movieObject.scenes[sceneIndex].elements[elementIndex]) {
                    const item = movieObject?.scenes[sceneIndex]?.elements[elementIndex] ?? null;
                    if (item) return {
                        pointer: item,
                        itemId: item.id,
                        sceneIndex: sceneIndex,
                        elementIndex: elementIndex,
                        type: "element"
                    }
                }
                return null;
            }
            else if (elementIndex === -1) {
                if (movieObject.scenes && movieObject.scenes[sceneIndex]) {
                    const item = movieObject?.scenes[sceneIndex] ?? null;
                    if (item) return {
                        pointer: item,
                        itemId: item.id,
                        sceneIndex: sceneIndex,
                        elementIndex: elementIndex,
                        type: "scene"
                    }
                }
                return null;
            }
            else return null;
        }
        else if (sceneIndex === -1) {
            if (elementIndex>=0) {
                if (movieObject.elements && movieObject.elements[elementIndex]) {
                    const item = movieObject?.elements[elementIndex] ?? null;
                    if (item) return {
                        pointer: item,
                        itemId: item.id,
                        sceneIndex: sceneIndex,
                        elementIndex: elementIndex,
                        type: "element"
                    }
                }
                return null;
            }
            else if (elementIndex === -1) {
                if (movieObject) {
                    const item = movieObject ?? null;
                    if (item) return {
                        pointer: item,
                        itemId: item.id,
                        sceneIndex: sceneIndex,
                        elementIndex: elementIndex,
                        type: "movie"
                    }
                }
                return null;
            }
            else return null;
        }
        else {
            return null;
        }
    }

    getItemCopyByCoords(sceneIndex, elementIndex) {
        const item = this.getItemByCoords(sceneIndex, elementIndex);
        if (item) return {
            pointer: JSON.parse(JSON.stringify(item.pointer)),
            itemId: item.itemId,
            sceneIndex: item.sceneIndex,
            elementIndex: item.elementIndex
        }
        return null;
    }

    // SELECT METHODS

    selectItemById(itemId) {
        this.selectedData = this.getItemById(itemId);
        // console.log("Selected item", this.selectedData);
        return this;
    }

    selectItemByCoords(sceneIndex, elementIndex) {
        this.selectedData = this.getItemByCoords(sceneIndex, elementIndex);
        return this;
    }

    isSelectedById(itemId) {
        return this.selectedData && this.selectedData.itemId === itemId;
    }

    // Internal: updates the selected item when the movie is updated
    __updateSelectedItem() {
        if (!this.selectedData) return;
        const newSelected = this.getItemById(this.selectedData.itemId);
        if (!newSelected) {
            this.selectedData = null;
        }
    }

    __resetSelectedItem() {
        this.selectedData = null;
    }

    // UPDATE METHODS

    updateMovie(movie) {
        let myNewMovie = JSON.parse(JSON.stringify(movie));
        this.movieObject = myNewMovie;
        this.__standarizeMovie();
        this.selectItemByCoords(-1, -1);
        return this;
    }

    updateScenes(scenes) {
        let myNewScenes = JSON.parse(JSON.stringify(scenes));
        this.movieObject.scenes = myNewScenes;
        this.__standarizeMovie();
        this.__updateSelectedItem();
        return this;
    }

    // updateProperties(itemId, properties, field = null) {
    //     // call __updateProperties only if this function hasn't been called for 1 second
    //     if (!this.__updatePropertiesTimeout) {
    //         this.__updatePropertiesTimeout = setTimeout(() => {
    //             this.__updatePropertiesTimeout = null;
    //             this.__updateProperties(itemId, properties, field);
    //         }, 1000);
    //     }
    // }

    updateProperties(itemId, properties, field = null) {
        const item = this.getItemById(itemId);
        // console.log("updateProperties().item: ", item);
        if (item) {
            if (field) {
                // redo the function to accept multiple levels of nesting
                let subItem = item.pointer;

                field.split(".").forEach(field => {
                    if (!subItem[field]) subItem[field] = {};
                    subItem = subItem[field];
                });

                Object.keys(properties).forEach(key => {
                    const value = properties[key];

                    let propertyArrayIndex;
                    [key, propertyArrayIndex] = key.split("/");

                    // console.log("Changing property", key, " to", value);

                    if (propertyArrayIndex) {
                        if (!Array.isArray(subItem[key])) subItem[key] = [];
                        subItem[key][propertyArrayIndex] = value;
                    }
                    else {
                        subItem[key] = value;
                    }
                });
            }
            else {
                Object.keys(properties).forEach(key => {
                    // console.log("Changing property", key, " to", properties[key]);
                    item.pointer[key] = properties[key];
                });
            }
            this.__standarizeMovie();
            this.__updateSelectedItem();
            // console.log("Updated item", this);
            return this;
        }
    }

    updateMovieProperty(property, value) {
        this.movieObject[property] = value;
        this.__standarizeMovie();
        return this;
    }

    // DELETE METHODS

    deleteItemById(itemId) {
        const item = this.getItemById(itemId);
        if (item) {
            return this.deleteItemByCoords(item.sceneIndex, item.elementIndex);
        }
        return null;
    }

    deleteItemByCoords(sceneIndex, elementIndex) {
        if (sceneIndex >= 0) {
            if (elementIndex>=0) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex] && this.movieObject.scenes[sceneIndex].elements && this.movieObject.scenes[sceneIndex].elements[elementIndex]) {
                    this.movieObject.scenes[sceneIndex].elements.splice(elementIndex, 1);
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
            else if (elementIndex === -1) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex]) {
                    this.movieObject.scenes.splice(sceneIndex, 1);
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }
        else if (sceneIndex === -1) {
            if (elementIndex>=0) {
                if (this.movieObject.elements && this.movieObject.elements[elementIndex]) {
                    this.movieObject.elements.splice(elementIndex, 1);
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
            else if (elementIndex === -1) {
                if (this.movieObject) {
                    this.movieObject.splice(elementIndex, 1);
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }

        return null;
    }

    // DUPLICATE METHODS

    duplicateItemById(itemId) {
        const item = this.getItemById(itemId);
        if (item) {
            return this.duplicateItemByCoords(item.sceneIndex, item.elementIndex);
        }
        return null;
    }

    duplicateItemByCoords(sceneIndex, elementIndex) {
        if (sceneIndex >= 0) {
            if (elementIndex>=0) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex] && this.movieObject.scenes[sceneIndex].elements && this.movieObject.scenes[sceneIndex].elements[elementIndex]) {
                    const item = this.movieObject.scenes[sceneIndex].elements[elementIndex];
                    delete item.id;
                    this.movieObject.scenes[sceneIndex].elements.push(JSON.parse(JSON.stringify(item)));
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
            else if (elementIndex === -1) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex]) {
                    const item = this.movieObject.scenes[sceneIndex];

                    // delete existing ids
                    delete item.id;
                    if (Array.isArray(item.elements)) {
                        for (let i = 0; i < item.elements.length; i++) {
                            delete item.elements[i].id;
                        }
                    }

                    // duplicate item
                    this.movieObject.scenes.push(JSON.parse(JSON.stringify(item)));
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }
        else if (sceneIndex === -1) {
            if (elementIndex>=0) {
                if (this.movieObject.elements && this.movieObject.elements[elementIndex]) {
                    const item = this.movieObject.elements[elementIndex];
                    delete item.id;
                    this.movieObject.elements.push(JSON.parse(JSON.stringify(item)));
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }

        return null;
    }

    replaceItemById(itemId, newItem) {
        const item = this.getItemById(itemId);
        if (item) {
            return this.replaceItemByCoords(item.sceneIndex, item.elementIndex, newItem);
        }
        return null;
    }

    replaceItemByCoords(sceneIndex, elementIndex, newItem) {
        if (sceneIndex >= 0) {
            if (elementIndex>=0) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex] && this.movieObject.scenes[sceneIndex].elements && this.movieObject.scenes[sceneIndex].elements[elementIndex]) {
                    this.movieObject.scenes[sceneIndex].elements[elementIndex] = newItem;
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
            else if (elementIndex === -1) {
                if (this.movieObject.scenes && this.movieObject.scenes[sceneIndex]) {
                    this.movieObject.scenes[sceneIndex] = newItem;
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }
        else if (sceneIndex === -1) {
            if (elementIndex>=0) {
                if (this.movieObject.elements && this.movieObject.elements[elementIndex]) {
                    this.movieObject.elements[elementIndex] = newItem;
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
            else if (elementIndex === -1) {
                if (this.movieObject) {
                    this.movieObject = newItem;
                    this.__standarizeMovie();
                    this.__updateSelectedItem();
                    return this;
                }
            }
        }
    }
}

export const defaultMovie = {
    comment: "Default movie",
    resolution: "full-hd",
    scenes: [
        {
            comment: "Scene 1",
            elements: []
        }
    ],
    elements: [
    ]
};